import React, { createContext, useContext, useState } from "react";

const QRModalContext = createContext();

export const QRModalProvider = ({ children }) => {
  const [show, setShow] = useState(false);
  const openQRModal = () => setShow(true);
  const closeQRModal = () => setShow(false);
  return (
    <QRModalContext.Provider value={{ show, openQRModal, closeQRModal }}>
      {children}
    </QRModalContext.Provider>
  );
};

export const useQRModal = () => useContext(QRModalContext);
